<template>
  <div
    :ref="'mef-cont-' + tabId"
    class="font mefo-container"
    @keydown="handleKeyDown"
    @keydown.enter.stop="handleKeyEnter"
    @keyup="handleKeyUp"
    v-if="showMe"
  >
    <mefHeader
      @closeMef="closeMefo()"
      @sortBy="sortName = $event"
      :minimizeAll="minimizeAll"
      @toggleFilters="showFilters = !showFilters"
      @toggleMini="minimizeAll = !minimizeAll"
      :gridMode="showGrid"
      @toggleGridMode="toggleGrid"
      :bookview="bookView"
      @toggleBookView="bookView = !bookView"
      :showFilters="showFilters"
      @toggleSearch="toggleSearchBar"
    />
    <freeSearchBarContainer
      :mefo="true"
      :searchId="searchId"
      v-if="hasMefoFreeSearch && freeSearchBookListStore && getShowSearchBar"
    />

    <Split
      class="flex-column"
      direction="vertical"
      :gutterSize="18"
      :class="{ 'hide-gutter': !showList }"
    >
      <SplitArea
        :size="50"
        :minSize="50"
        v-show="hasMefoFreeSearch && showList && getShowSearchBar"
      >
        <FreeSearchList
          class="free-search-area"
          v-show="showList"
          :mefo="true"
          @scrollToSec="
            (v) => {
              scrollIntoView(v);
            }
          "
          :searchId="searchId"
        />
      </SplitArea>
      <SplitArea
        :size="100"
        :class="{ 'freelist-hidden': !showList }"
        class="search-book-list"
      >
        <div class="flex-column h-100 meforshim-container">
          <bookListHandle
            class="top"
            v-show="hasMefoFreeSearch && !showList && getShowSearchBar"
            txt="v"
            @click="toggleShowFreeSearchList"
          />
          <mefFilters
            @filter="(f) => (filters = f)"
            v-show="showFilters"
            :mefarshim="filters.txtFilter == '' ? mefarshim : mefarshimToshow"
          />
          <mefSectionsHeader
            v-show="showFilters"
            @sortBy="sortName = $event"
            :minimizeAll="minimizeAll"
            @toggleMini="minimizeAll = !minimizeAll"
            :gridMode="showGrid"
            @toggleGridMode="toggleGrid"
            :bookview="bookView"
            @toggleBookView="bookView = !bookView"
          />

          <div class="mef-scroller">
            <img
              v-if="$store.state.mefo.loading"
              src="@/assets/img/bookloader.svg"
            />

            <div ref="sectionsContaier" class="sectionsContaier">
              <div class="mef-net-msg" v-if="noPlaceOnTheServer || kickOut">
                <p v-if="noPlaceOnTheServer">{{ $t("mefo.noPlace") }}</p>
                <p v-if="kickOut">{{ $t("mefo.disconnected") }}</p>
              </div>

              <template v-else v-for="(mefSec, i) in mefarshimToshow">
                <mefSectionCard
                  :enterclicked="enterclicked"
                  @setSecInx="setSecInx"
                  :ref="'mefSectionCard_'"
                  :resize_trigger="resize_trigger"
                  @enter="insertIntoView(mefSec.index, i)"
                  @saveTempImg="saveTempImg"
                  @changefavorite="changefavorite"
                  :tempBookImages="tempImages[mefSec.book]"
                  :shasSecSelected="shasSecSelected"
                  :loadContent="
                    intersected.sectionsToLoad[mefSec.id] || mefSec.index < 5
                  "
                  :key="'mc' + mefSec.id"
                  :mefSection="mefSec"
                  :bookView="mefSec.yesod == 'cat' ? true : bookView"
                  :minimizeAll="minimizeAll"
                  :showGrid="showGrid"
                  :currentIndex="i"
                  :fsActive="mefSec.index == indexSec"
                  :searchId="searchId"
                  @scrollToSec="
                    (v) => {
                      scrollIntoView(v);
                    }
                  "
                ></mefSectionCard>
              </template>
            </div>
          </div>
        </div>
      </SplitArea>
    </Split>
  </div>
</template>

<script>
import * as mefo from "@/services/mefo/mefo.js";
import mefSectionCard from "@/components/mefo/mefSectionCard.vue";
import filterRow from "@/components/mefo/filterRow.vue";
import mefHeader from "./mefoHeaderBar.vue";
import mefFilters from "./mefoFilters.vue";
import mefSectionsHeader from "./mefSectionsHeader.vue";
import bookListHandle from "@/components/listBookArea/freeSearchBarContainer/bookListHandle.vue";
//import * as mefConnection from "@/services/mefConnection.js";
import { mapActions, mapGetters, mapState } from "vuex";
import freeSearchBarContainer from "@/components/listBookArea/freeSearchBarContainer/freeSearchBarContainer.vue";
import FreeSearchList from "@/components/listBookArea/freeSearchListContainer.vue";
import { createFreeSearchBookListStore } from "@/store_pinia";

const mefarshimData = new Map();
export default {
  components: {
    mefSectionCard,
    filterRow,
    mefHeader,
    mefFilters,
    mefSectionsHeader,
    freeSearchBarContainer,
    FreeSearchList,
    bookListHandle,
  },
  props: ["tabId", "resize_trigger", "shasSecSelectedId"],
  data() {
    return {
      componentId: null,
      refreshDataTrigger: false, //changes to be reactive
      lastOne: [],
      tempImages: {},
      intersected: { sectionsToLoad: {}, index: 0 },
      mefarshim: [],
      showGrid: false,
      bookView: false,
      minimizeAll: false,
      showFilters: true,
      enableFilters: true,
      srchStr: "",
      applySearch: "",
      filters: { type: ["s", "d", "p", "z", "h"], gen: null, txtFilter: "" },
      sortName: "default",
      indexSec: 0,
      enterclicked: false,
      favorites: [],
    };
  },
  computed: {
    ...mapGetters("mefo", ["getSectionBookPages", "getShowSearchBar"]),
    showMe() {
      return (
        this.$store.state.tabs[this.tabId] &&
        this.$store.state.tabs[this.tabId].SHAS_SECTION_LIST_ID
      );
    },
    searchId() {
      return this.shasSecSelected[0]?.id;
    },
    freeSearchBookListStore() {
      return this.searchId
        ? createFreeSearchBookListStore(this.searchId)
        : null;
    },
    hasMefoFreeSearch() {
      return this.otzarVersion >= 22;
    },
    showList() {
      return this.freeSearchBookListStore?.showList || false;
    },
    favoritesBooks() {
      const book = this.$store.state.tabs[this.tabId].book;
      let res = this.$store.state.mefo.userFavs[book] || [];
      return res;
    },
    shasSecSelected() {
      //if (this._mobile) return this.$store.state.mefo.currentShasSectionId;
      let sec =
        this.$store.state.tabs[this.tabId] &&
        this.$store.state.tabs[this.tabId].shasSecSelected;

      return sec;
    },
    showMefoArea() {
      return this.$store.state.mefo.showMefoArea;
    },
    noPlaceOnTheServer() {
      return this.$store.state.mefo.no_space;
    },
    kickOut() {
      return this.$store.state.mefo.kickout;
    },

    mefarshimToshow() {
      let mefarshim = this.mefarshim;
      //filter dups (which have diffrent type like h and p ...)

      if (this.mefarshim.length == 0) return [];
      mefarshim = mefarshim.filter((a) => {
        return (
          a.rects.length &&
          this.$store.getters["books/getBookbyId"](a.book, true)
        );
      });

      /*  mefarshim = mefarshim.filter((a) => {
        return (
          a.rects.length &&
          (this.$store.state.bookOnlyMode ||
            this.$store.getters["books/getBookbyId"](a.book, true))
        );
      }); */

      mefarshim.forEach((obj) => {
        if (
          this.favoritesBooks.some(
            (fav) =>
              fav.book === obj.book && fav.subbook === obj.rects[0].subbook
          )
        ) {
          obj["isfavorite"] = true;
        }
      });

      //filter by text

      this.applySearch = this.filters.txtFilter.trim();
      if (this.applySearch) {
        this.applySearch = this.applySearch.trim();
        mefarshim = mefarshim.filter((s) => {
          try {
            const subbook = s.rects[0] ? s.rects[0].subbook : 0;
            if (subbook) {
              return (
                !s.otzarBook || //TODO book not recognize
                s.otzarBook.subBooks[subbook].name.indexOf(this.applySearch) >
                  -1 ||
                s.otzarBook.subBooks[subbook].author.indexOf(this.applySearch) >
                  -1 ||
                s.otzarBook.subBooks[subbook].volume?.indexOf(
                  this.applySearch
                ) > -1
              );
            } else
              return (
                !s.otzarBook || //TODO book not recognize
                s.otzarBook.name.indexOf(this.applySearch) > -1 ||
                s.otzarBook.authors_0_name.indexOf(this.applySearch) > -1 ||
                s.otzarBook.volume?.indexOf(this.applySearch) > -1
              );
          } catch (error) {
            return s; //TODO
          }
        });
      }

      if (this.filters.type && this.filters.enabled) {
        const filters = this.filters.type.flatMap((item) =>
          item.includes("^") ? item.split("^") : [item]
        );

        mefarshim = mefarshim.filter((s) => filters.includes(s.type));
      }

      if (this.filters.gen && this.filters.enabled) {
        mefarshim = mefarshim.filter((s) => {
          //new way dor
          const n = 1 << (Number(this.filters.gen) - 1);
          //return !s.otzarBook || this.filters.gen.includes(s.otzarBook.dor) //old
          return !s.otzarBook || n & s.otzarBook.dor; //new way
        });
      }

      if (this.sortName == "default") {
        mefarshim.sort((a, b) => {
          const eq = this.compareFav(a, b);
          if (eq != 0) return eq;
          return a.level - b.level;
        });
      }
      if (this.sortName == "alefbet") {
        mefarshim.sort((a, b) => {
          //TODO unknow book
          const eq = this.compareFav(a, b);
          if (eq != 0) return eq;
          if (!(a.otzarBook && b.otzarBook)) return 0;
          return a.otzarBook.name < b.otzarBook.name
            ? -1
            : a.otzarBook.name > b.otzarBook.name
            ? 1
            : 0;
        });
      }
      for (let i = 0; i < mefarshim.length; i++) mefarshim[i].index = i;
      let tmp = [];
      const res = mefarshim;
      for (let i = 0; i < res.length - 1; i++) {
        //get the current one
        const a = res[i];
        let b = null;
        for (let x = i + 1; x < res.length; x++) {
          b = res[x];
          if (
            b.otzarBook.id == a.otzarBook.id &&
            a.rects.length == b.rects.length &&
            a.type != b.type &&
            a.rects.map((a) => a.id).join(",") ==
              b.rects.map((b) => b.id).join(",")
          ) {
            // found double
            b = null;
            break;
          } else if (b.otzarBook.id != a.otzarBook.id) {
            break;
          }
        }
        if (b == null) {
          //double
          continue;
          //else we have double
        } else tmp.push(a);
      }

      //add the last one
      if (res.length) tmp.push(res[res.length - 1]);
      mefarshim = tmp;
      //set correct index to SectionBookPages
      const sectionData = this.getSectionBookPages;
      const sectionId = this.mefarshim[0].pageSectionId;
      mefarshim.forEach((m, i) => {
        const secData = sectionData.get(sectionId);
        if (secData)
          for (const [k, v] of Object.entries(secData)) {
            if (v.id2 == m.id) {
              v.index = i;
              // continue;
            }
          }
      });
      this.setSectionBookPages({
        sectionId,
        data: sectionData.get(sectionId),
      });

      return mefarshim; //.slice(0, 25);
    },
  },
  methods: {
    toggleShowFreeSearchList() {
      this.freeSearchBookListStore.toggleShowFreeSearchList();
    },
    handleKeyEnter(event) {
      if (event.target.nodeName == "INPUT") return;
      if (event.keyCode === 13) {
        this.enterclicked = this.indexSec;
      }
    },
    setSecInx(inx) {
      this.indexSec = inx;
    },
    handleKeyDown(event) {
      if (event.key === "ArrowDown") {
        this.scrollIntoView();
        if (this.indexSec < this.mefarshimToshow.length - 1) {
          this.indexSec++;
        }
      }
    },
    handleKeyUp(event) {
      if (event.key === "ArrowUp") {
        this.scrollIntoView();
        if (this.indexSec > 0) {
          this.indexSec--;
        }
      }
    },
    scrollIntoView(ind) {
      if (ind !== undefined) this.indexSec = ind;
      this.$nextTick(() => {
        const refs = this.$refs["mefSectionCard_"];
        let ref;
        if (refs) {
          ref = refs[this.indexSec];
        }
        if (ref && ref.$el) {
          ref.$el.scrollIntoView({ behavior: "smooth" });
          setTimeout(() => {
            ref.$el.scrollIntoView({ behavior: "smooth" });
          }, 2000);
        }
      });
    },
    compareFav(a, b) {
      if (a.isfavorite === b.isfavorite) return 0;
      else if (a.isfavorite) return -1;
      return 1;
    },
    async changefavorite(masid, bookid, mefSec) {
      const sub = mefSec.rects[0].subbook;
      if (mefSec.hasOwnProperty("isfavorite")) {
        for (let i = 0; i < this.mefarshim.length; i++) {
          const item = this.mefarshim[i];
          if (item.book === bookid && item.rects[0].subbook === sub) {
            delete this.mefarshim[i]["isfavorite"];
          }
        }
        await mefo.deleteMefoFavs(masid, bookid, sub);
      } else {
        await mefo.setMefoFavs(masid, bookid, sub);
      }
    },
    ...mapActions("tabsManager", ["toggleSplitter", "showSidebar"]),
    ...mapActions("mefo", ["setSectionBookPages", "toggleSearchBar"]),

    resetOptions() {
      //dont reset it
      this.showGrid = false;
      this.bookView = false;
      this.minimizeAll = false;
      /*  this.showFilters = true;
      this.enableFilters = true;
      this.srchStr = "";
      this.applySearch = "";
      this.filters = {
        type: ["s", "d", "p", "z", "h"],
        gen: null,
        txtFilter: "",
      };
      this.sortName = "default"; */
    },
    toggleGrid() {
      if (!this.showGrid && this.minimizeAll) this.minimizeAll = false;
      this.showGrid = !this.showGrid;
      this.userSettings.setSettings("mefoDefaultGrid", this.showGrid);
    },
    saveTempImg(img, book, pageId) {
      if (!this.tempImages[book]) this.tempImages[book] = {};
      this.tempImages[book][pageId] = img;
    },
    async insertIntoView(index, i) {
      if (i != index);
      this.intersected.index = index;
      const indxToShow = [];
      for (let i = index - 2; i < index + (this.minimizeAll ? 20 : 4); i++)
        indxToShow.push(i);

      //timeout - if quick scroll
      // maybe this.intersected.index changed
      await new Promise((res, rej) => setTimeout(res, 250));
      if (!indxToShow.includes(this.intersected.index)) return;

      for (const section of this.mefarshimToshow) {
        const isInNextGroup = indxToShow.includes(section.index);
        if (isInNextGroup) {
          this.$set(this.intersected.sectionsToLoad, section.id, true);
        }
      }
    },
    closeMefo() {
      this.$store.dispatch(`mefo/setShowMefoArea`, false);
    },
    toggleMefoSearchBar() {
      this.$store.dispatch(`mefo/toggleSearchBar`);
    },
    async loadResults() {
      if (!this.shasSecSelected?.length) return;
      let res = await mefo.getMefoSectionsByShasId(
        this.shasSecSelected.map((a) => a.id)
      );

      mefarshimData.set(this.componentId, res);
      this.mefarshim = res;
      this.setMefData();
      this.$store.dispatch("mefo/setLoading", false);
    },
    setMefData() {
      //set books and pages of mefarshim for freesearch
      if (this.mefarshim[0]) {
        const sectionId = this.mefarshim[0].pageSectionId;

        const sectionData = this.getSectionBookPages;
        if (!sectionData || !sectionData.has(sectionId)) {
          const data = {};
          this.mefarshim.forEach((m, i) => {
            m.rects.forEach((r) => {
              const bookData = data[r.book];
              if (bookData) {
                bookData.id1 = r.id;
                bookData.id2 = r.rectMefoId;
                //  bookData.index = i;
                if (bookData.pages) bookData.pages.add(r.page);
                else bookData.pages = new Set([r.page]);
              } else {
                data[r.book] = {};
                data[r.book].id1 = r.id;
                data[r.book].id2 = r.rectMefoId;
                data[r.book].pages = new Set([r.page]);
                //   data[r.book].index = i;
              }
            });
          });

          for (let key in data) {
            data[key].pages = Array.from(data[key].pages);
          }
          this.setSectionBookPages({
            sectionId,
            data,
          });
        }
      }
    },
    addMe() {
      let elem =
        this.$refs["mef-cont-" + this.tabId].querySelector(".gutter-vertical");
      // let elem = document
      //   .getElementById("container-main")
      //   .children("gutter-horizontal");

      /** @type {HTMLElement} */
      let divElem = elem;
      // divElem.onclick = this.toggleList;

      let htmlElem = `<svg xmlns="http://www.w3.org/2000/svg" width="11.971" height="61" viewBox="0 0 11.971 61"  class="handle-list"
          style='position: absolute; left: 50%; transform: translateX(-50%); cursor: pointer; transform: translateY(0) translateX(-50%) rotate(-90deg);top: -24.5px;'  >
  <g id="Group_3700" data-name="Group 3700" transform="translate(225.971 468) rotate(180)">
    <path id="Path_3823" data-name="Path 3823" d="M0,0,11.971,5V56L0,61Z" transform="translate(214 407)" />
    <g id="חץ_לקומבו" data-name="חץ לקומבו" transform="translate(221.058 434.283) rotate(90)">
      <g id="Group_23" data-name="Group 23">
        <path id="Path_23" data-name="Path 23" d="M0,.022,2.654,2.907,5.329,0" transform="translate(0 0)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="0.989"/>
      </g>
    </g>
  </g>
</svg>

`;
      // htmlElem.onclick = this.toggleList;
      if (divElem) {
        divElem.innerHTML = htmlElem;
        divElem.children[0].onclick = this.toggleShowFreeSearchList;
      }
    },
  },
  created() {
    this.componentId = Math.random(1 % 10000000);
    mefarshimData.set(this.componentId, {});
  },
  beforeDestroy() {
    mefarshimData.delete(this.componentId);
    this.refreshDataTrigger = !this.refreshDataTrigger;
  },
  mounted() {
    if (!this.showMe) return;
    this.addMe();
    // todo
    // this.$el.addEventListener("keydown", this.handleKeyDown);
    // this.$el.addEventListener("keyup", this.handleKeyUp);
    // this.$el.addEventListener("keyup", this.handleKeyEnter);
    this.loadResults();
    if (this.userSettings.settings.mefoDefaultGrid != undefined) {
      this.showGrid =
        this.userSettings.settings.mefoDefaultGrid == 1 ? true : false;
    }
  },
  watch: {
    shasSecSelected: function (val, oldV) {
      let same = true;
      for (let i = 0; i < val.length; i++) {
        if (!this.lastOne[i] || this.lastOne[i].id != val[i].id) {
          same = false;
          break;
        }
      }

      if (!oldV || !same) {
        this.lastOne = [...val];
        //show lst always
        //disable by erez :-)
        // this.resetOptions();
        this.showSidebar();
        this.toggleSplitter();

        this.tempImages = {};
        this.mefarshim = [];
        this.intersected.sectionsToLoad = {};
        this.loadResults();
      }
    },
    showMefoArea: function (val, oldV) {
      this.toggleSplitter();
    },
  },
};
</script>

<style lang="scss" scoped>
.mefo-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: var(--main-bg-color);
}
.mef-scroller {
  overflow: scroll;
  direction: ltr;
  flex-grow: 1;
  background-color: whitesmoke;
}
.sectionsContaier {
  overflow: auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  direction: ltr;
  background-color: var(--main-bg-color);
}
.FilterTitle {
  /* color: #00a6a6; */
  padding-left: 11px;
  padding-right: 11px;
  font-size: 14px;
  font-weight: 500;
  text-align: right;
  border-bottom-style: solid;
  border-bottom-width: 1px;
  border-bottom-color: #dedede;
  height: 39px;
  display: flex;
  /* align-content: center; */
  align-items: center;
}

.FilterContainer {
  text-align: center;
  direction: rtl;

  background-color: #f5f5f5;
  // position: sticky;
  height: fit-content;
  width: 100%;
  top: 0px;
  z-index: 3;
}
.header-buttons span {
  cursor: pointer;
  padding: 2px 4px;
  // margin: 0px 1px;
  border-radius: 0.1rem;
  // background-color: rgba(128, 128, 128, 0.247);
}
.header-buttons span:hover {
  background-color: rgba(128, 128, 128, 0.384);
}
.mef-net-msg {
  margin: 10px;
  font-size: 14px;
  font-weight: 600;
}
.freelist-hidden {
  height: 100% !important;
  position: relative;
}
.meforshim-container {
  height: calc(100% - 11px);
  &::before {
    content: "";
    display: block;
  }
}
</style>
